const NAMESPACE = 'CONTENT_DATA';

const SET_CONTENT_DATA = `${NAMESPACE}/SET_CONTENT_DATA`;

export {
    SET_CONTENT_DATA,
};

export default NAMESPACE;
